import { changeCarModel } from "src/module/carModel/carModel";
import { changeSliderDesign } from "src/module/slider/slider";
import History, { showHistory } from "src/module/history/history";
import style from "./applyDesign.css";

const kzs = window.kzs;
const $ = kzs.$;

export const applyDesign = (): void => {
  console.log("variations/applyDesign");

  style.use();

  // フローシングメニュー表示制御
  $(".trac_menu").hide();
  $(window).off("scroll.firstView");
  $(window).one("scroll.firstView", () => {
    $(".trac_menu").fadeIn();
  });

  // スライダー
  changeSliderDesign();

  // 車種情報更新
  changeCarModel();

  // 閲覧履歴表示
  showHistory(History);
};
